import ProgressBar from 'components/ProgressBar'
import Nav from 'components/Nav'
import SubNav from 'components/SubNav/SubNav'
import NotificationBar from 'components/Notification/NotificationBar'
import _ from 'lodash'
import BillingReminder from 'components/BillingReminder'

class LayoutNotLoggedIn extends React.Component {
  render () {
    let { data, history, dispatch, location, routes, children } = this.props
    let {pathname} = location
    let {moka, notification, subscriptionExpired} = data
    let { loggedIn, user, permissions } = moka
    let hideHeader = routes[1].hideHeader
    let subMenuOf = _.groupBy(permissions, (permission) => permission.menu.toLowerCase())

    return (
      <div className={'full-height'}>
        <ProgressBar updateTime={500} currentPath={pathname} />
        {!hideHeader && <header className='mk-head-bar'>
          <Nav
            loggedIn={loggedIn}
            user={user}
            subMenuOf={subMenuOf}
            history={history}
            dispatch={dispatch}
            location={location}
            />
            {pathname.startsWith('/reports') &&
            <SubNav
              links={this._toLinks(subMenuOf['reports'])}
              location={location}
              user={user}
              subscriptionExpired={subscriptionExpired}
            />
          }
          {pathname.startsWith('/settings') &&
            <SubNav
              links={this._toLinks(subMenuOf['account settings'])}
              location={location}
              user={user}
              subscriptionExpired={subscriptionExpired}
            />
          }
          {pathname.startsWith('/library') &&
            <SubNav
              links={this._toLinks(subMenuOf['library'])}
              location={location}
              user={user}
              subscriptionExpired={subscriptionExpired}
            />
          }
          {pathname.startsWith('/customers') &&
            <SubNav
              links={this._toLinks(subMenuOf['customers'])}
              location={location}
              user={user}
              subscriptionExpired={subscriptionExpired}
            />
          }
          {pathname.startsWith('/employees') &&
            <SubNav
              links={this._toLinks(subMenuOf['employees'])}
              location={location}
              user={user}
              subscriptionExpired={subscriptionExpired}
            />
          }
          {pathname.startsWith('/outlets') &&
            <SubNav
              links={this._toLinks(subMenuOf['outlets'])}
              location={location}
              user={user}
              subscriptionExpired={subscriptionExpired}
            />
          }
          {pathname.startsWith('/inventory') &&
            <SubNav
              links={this._toLinks(subMenuOf['inventory'])}
              location={location}
              user={user}
              subscriptionExpired={subscriptionExpired}
            />
          }
          {pathname.startsWith('/ingredient') &&
            <SubNav
              links={this._toLinks(subMenuOf['ingredient'])}
              location={location}
              user={user}
              subscriptionExpired={subscriptionExpired}
            />
          }
          {!hideHeader && <NotificationBar dispatch={dispatch} notification={notification} location={location} /> }
        </header>}

        <div className='separator' />
        <div className={`full-height section-content ${hideHeader ? ' no-header' : ''} ${this._getClassByPath()}`}>
          <div className='visible-sm visible-xs reminder-responsive'>
            <BillingReminder user={user} subscriptionExpired={subscriptionExpired} />
          </div>
          <div className='container-full-nosub box-content-container not-logged-in'>
            {children}
          </div>
        </div>
      </div>
    )
  }

  _getClassByPath () {
    let {location} = this.props
    let classbyPath = location.pathname.split('/')
    if (location.pathname.startsWith('/feedback')) {
      return 'feedback'
    }
    if (classbyPath[1] === 'reset-password') {
      return 'reset-password'
    }
    return classbyPath[classbyPath.length - 1]
  }

  _toLinks = (subMenus) => {
    let isMobile = window.innerWidth <= 768
    let links = []
    let sortedSubMenu = _.orderBy(subMenus, 'priority_rank')
    for (let i = 0; i < sortedSubMenu.length; i++) {
      const subMenu = sortedSubMenu[i]
      if (isMobile && !subMenu.mobile_supported) {
        continue
      }
      links.push({
        href: subMenu.urls[0],
        label: subMenu.sub_menu
      })
    }
    return links
  }
}

export default LayoutNotLoggedIn



// WEBPACK FOOTER //
// ./app/components/Layout/LayoutNotLoggedIn/LayoutNotLoggedIn.js